import React from 'react';

const jobs = [
  {
    company: 'Filmetrics Corporation',
    title: 'Software Developer Intern',
    period: '2025',
    bullets: [
      'Developed full-stack web features using JavaScript, Node.js, Vue.js, and PostgreSQL.',
      'Collaborated in Agile sprints, debugging backend API endpoints and enhancing UI responsiveness.',
    ],
  },

];

export default function Experience() {
  return (
    <section id="experience" className="container experience">
      <h2>Experience</h2>
      {jobs.map((j) => (
        <div className="job" key={j.company}>
          <h4>
            {j.title} — <span className="muted">{j.company}</span>
          </h4>
          <div className="period">{j.period}</div>
          <ul>
            {j.bullets.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
